import axios from '@/axios'
import { Notify, Loading, QSpinnerTail } from 'quasar'
export default {
  state: {
    rooms: []
  },
  mutations: {
    setAllRooms (state, data) {
      let roomList = []
      data.forEach(e => {
        let receiverId = e.user2.id
        let receiverName = e.user2.name
        if (data.loggedUser === receiverId) {
          receiverId = e.user1.id
          receiverName = e.user1.name
        }
        roomList.push({
          roomId: e.roomId,
          receiverId,
          receiverName,
          messages: []
        })
      })
      state.rooms = roomList
    },
    setMessages (state, data) {
      console.log(data)
      let messageList = []
      let lastDate = ''
      let writerId = ''
      let index = state.rooms.findIndex(e => data.roomId === e.roomId)
      data = data.reverse()
      data.forEach(e => {
        writerId = e.userId
        let date = new Date(e.createdDate)
        let dateString = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`
        let hourString = `${date.getHours() + 1}:${date.getMinutes() + 1}`
        if (lastDate !== dateString) {
          lastDate = dateString
          messageList.push({ id: dateString, type: 'DATE', date })
        }
        let msg = { id: e.id, text: [e.content], sent: false, type: 'MESSAGE', hour: hourString, date }
        if (writerId === data.loggedUser) {
          msg.sent = true
        }
        messageList.push(msg)
      })
      state.rooms[index].messages = messageList
    },
    emitterUpdateMsg (state, data) {
      let room = state.rooms.findIndex(e => e.roomId === data.room.roomId)
      let date = new Date(data.createdDate)
      let hourString = `${date.getHours() + 1}:${date.getMinutes() + 1}`
      let msg = { id: data.id, text: [data.content], sent: false, hour: hourString }
      if (state.rooms[room].receiverId === data.userId) {
        msg.sent = true
      }
      state.rooms[room].messages.push(msg)
    }
  },
  getters: {
    getReceiverName: state => roomId => {
      let roomData = state.rooms.find(e => e.roomId === roomId)
      if (roomData !== undefined) {
        return roomData.receiverName
      }
      return ''
    },
    getMessages: state => roomId => {
      let roomData = state.rooms.find(e => e.roomId === roomId)
      if (roomData !== undefined) {
        return roomData.messages
      }
      return []
    },
    getAllRooms: state => {
      return state.rooms
    },
    getReceiverIdFromRoom: state => roomId => {
      let roomData = state.rooms.find(e => {
        return e.roomId === roomId
      })
      return roomData.receiverId
    }
  },
  actions: {
    startChat ({ dispatch }, id) {
      axios.get(`platform/chat/room/${id}`)
        .then(res => {
          dispatch('createRoom', res.data.owner.id)
        })
        .catch(err => {
          console.log(err)
        })
    },
    postMsg ({ commit }, { roomId, msg }) {
      axios.post(`platform/chat/send-msg/${roomId}`, {
        content: msg
      })
    },
    getAllRooms ({ commit, rootState }) {
      axios.get('platform/chat/room/pagination?limit=999&page=0')
        .then(res => {
          let json = res.data.content
          json.loggedUser = rootState.user.userData.id
          commit('setAllRooms', json)
        })
        .catch(err => {
          console.log(err.response)
        })
    },
    getMessagesByRoom ({ commit, rootState }, roomId) {
      axios.get(`platform/chat/room/${roomId}/messages?limit=999&page=0`)
        .then(res => {
          let json = res.data.content
          json.loggedUser = rootState.user.userData.id
          json.roomId = roomId
          commit('setMessages', json)
        })
        .catch(err => {
          console.log(err.response)
        })
    },
    createRoom ({ dispatch }, id) {
      Loading.show({ spinner: QSpinnerTail, spinnerSize: 80, spinnerColor: 'blue' })
      axios.post(`/platform/chat/room/start/user/${id}`)
        .then(res => {
          dispatch('getAllRooms')
          Loading.hide()
          Notify.create({
            message: 'Sala criada para cotação, verifique seu chat',
            position: 'top',
            color: 'positive'
          })
        })
        .catch(err => {
          console.log(err)
          Loading.hide()
        })
    }
  }
}
